import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { debounce } from "lodash";
import { Col, Form, Input, PageHeader, Row, Select, Table } from "antd";
import moment from "moment-jalaali";

import { GetUrlParams, ObjectToURL, PriceFormat } from "scripts/helpers";
import { setRoute } from "scripts/reducer";
import API from "scripts/api";
import Resources from "scripts/resources";

const Component = ({ onSetRoute, parentName, routeName }) => {
	const initialState = { data: [], pagination: {} };
	const tableColumns = [
		{
			title: Resources.row,
			dataIndex: "index",
			className: "center-cell",
			width: "60px",
			render: (value, record, index) =>
				(pagination.current - 1) * pagination.pageSize + index + 1,
		},
		{
			title: `${Resources.name} ${Resources.user}`,
			dataIndex: "user",
			render: (value) => value?.fullName,
		},
		{
			title: Resources.title,
			dataIndex: "title",
			className: "center-cell",
		},
		{
			title: Resources.amount,
			dataIndex: "gatewayPaidAmount",
			className: "center-cell",
			render: (value, record) => PriceFormat(value + record.walletPaidAmount),
		},
		{
			title: Resources.gateway,
			dataIndex: "gateway",
			className: "center-cell",
		},
		{
			title: Resources.status,
			dataIndex: "status",
			className: "center-cell color-cell",
			width: "100px",
			render: (value) => (
				<span className={value ? "green" : "red"}>
					{value ? Resources.success : Resources.unsuccess}
				</span>
			),
		},
		{
			title: Resources.date,
			dataIndex: "paymentDate",
			className: "center-cell desc-cell ltr-cell",
			width: "100px",
			render: (value) => {
				const [date, time] = moment(value)
					.format(process.env.REACT_APP_DATE_TIME_FORMAT_JALALI)
					.split(" ");

				return (
					<>
						<span className="name">{date}</span>
						<small className="desc">{time}</small>
					</>
				);
			},
		},
	];
	const [state, setState] = useState(initialState);
	const { data, loading, pagination } = state;
	const { pathname, search } = useLocation();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const fetchData = () => {
		const params = GetUrlParams(search);

		form.resetFields();
		form.setFieldsValue(params);

		setState((prevState) => ({ ...prevState, loading: true }));

		API.transactions({ ...params, pageSize: process.env.REACT_APP_PAGE_SIZE })
			.then(({ transactions: data, meta: { currentPage, perPage, total } }) => {
				setState((prevState) => ({
					...prevState,
					data,
					pagination: {
						current: currentPage,
						pageSize: perPage,
						total,
						showSizeChanger: false,
					},
					loading: false,
				}));
			})
			.catch(() => {
				setState((prevState) => ({ ...prevState, loading: false }));
			});
	};

	const handleTable = ({ current }) => {
		const params = GetUrlParams(search);
		const query = ObjectToURL({ ...params, page: current });

		navigate(`${pathname}?${query}`);
	};

	const handleFilter = debounce(() => {
		form.validateFields().then((values) => {
			const search = ObjectToURL({ page: 1, ...values });

			navigate(`${pathname}?${search}`);
		});
	}, 1000);

	const componentDidUpdate = () => {
		fetchData();
	};

	const componentDidMount = () => {
		onSetRoute({ openKey: parentName, selectedKey: routeName });
	};

	useEffect(componentDidUpdate, [search]);
	useEffect(componentDidMount, []);

	return (
		<>
			<PageHeader title={`${Resources.transaction}${Resources.ha}`} />
			<Form layout="vertical" form={form}>
				<Row gutter={24}>
					<Col xs={24} sm={12} md={8} lg={6} xxl={4}>
						<Form.Item name="search">
							<Input
								suffix={<i className="fa fa-search" />}
								onChange={handleFilter}
								placeholder={Resources.search}
								allowClear
								autoFocus
							/>
						</Form.Item>
					</Col>
					<Col xs={24} sm={12} md={8} lg={6} xxl={4}>
						<Form.Item name="status">
							<Select
								placeholder={Resources.status}
								options={[
									{ value: "true", label: Resources.success },
									{ value: "false", label: Resources.unsuccess },
								]}
								onChange={handleFilter}
								allowClear
							/>
						</Form.Item>
					</Col>
					<Col xs={24} sm={12} md={8} lg={6} xxl={4}>
						<Form.Item name="type">
							<Select
								placeholder={Resources.type}
								options={[
									{ value: "income", label: Resources.income },
									{ value: "expense", label: Resources.cost },
								]}
								onChange={handleFilter}
								optionFilterProp="value"
								showSearch
								allowClear
							/>
						</Form.Item>
					</Col>
				</Row>
			</Form>
			<Table
				columns={tableColumns}
				dataSource={data}
				loading={loading}
				onChange={handleTable}
				pagination={pagination}
				scroll={{ x: 930 }}
				rowKey="id"
			/>
		</>
	);
};

export default connect(
	(state) => {
		return {};
	},
	(dispatch) => {
		return {
			onSetRoute: (data) => dispatch(setRoute(data)),
		};
	}
)(Component);
